export default __webpack_public_path__ + "static/media/in_waranty_car_category.779dad17.png";